import { render, staticRenderFns } from "./EditMngInf.vue?vue&type=template&id=6f56f704&scoped=true"
import script from "./EditMngInf.vue?vue&type=script&lang=js"
export * from "./EditMngInf.vue?vue&type=script&lang=js"
import style0 from "./EditMngInf.vue?vue&type=style&index=0&id=6f56f704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f56f704",
  null
  
)

export default component.exports